"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAlcohol = createAlcohol;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
const alcohol_1 = require("../../../forms/ktx/transplantation-screening/medical-history/risks/alcohol");
const messages = {
    alcohol: {
        id: "ktx.dashboard.alcohol",
        defaultMessage: "Alkohol fogyasztás"
    },
    currentAlcoholUse: {
        id: "ktx.dashboard.alcohol.current_alcohol_use",
        defaultMessage: "Aktuálisan fogyaszt alkoholt"
    },
    currentAlcoholAbuse: {
        id: "ktx.dashboard.alcohol.current_alcohol_abuse",
        defaultMessage: "Aktuálisan alkoholfüggőség gyanúja felmerül"
    },
    anamnesticAlcoholAbuse: {
        id: "ktx.dashboard.alcohol.anamnestic_alcohol_abuse",
        defaultMessage: "Anamnézisében szerepel alkoholfüggőség"
    }
};
function createAlcohol({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.medicalHistoryQueries.alcohol);
    if (event === undefined) {
        return undefined;
    }
    const items = [
        {
            type: "list-item",
            label: formatMessage(messages.currentAlcoholUse),
            value: formatMessageMap(alcohol_1.currentAlcoholUseMessages, event.value.currentAlcoholUse)
        }
    ];
    if (event.value.currentAlcoholAbuse) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.currentAlcoholAbuse),
            value: formatMessageMap(alcohol_1.currentAlcoholAbuseMessages, event.value.currentAlcoholAbuse)
        });
    }
    if (event.value.anamnesticAlcoholAbuse) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.anamnesticAlcoholAbuse),
            value: formatMessageMap(alcohol_1.anamnesticAlcoholAbuseMessages, event.value.anamnesticAlcoholAbuse)
        });
    }
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        origin,
        label: formatMessage(messages.alcohol),
        items
    };
}
